import {
  isMatriculaCocheValid,
  normalizeMatricula,
} from '../../../../../common/constants/matriculaValidation'

export class Matricula {
  private readonly valor: string

  constructor(matricula: string) {
    if (!Matricula.isValid(matricula)) {
      throw new Error('Formato de matrícula inválido')
    }
    this.valor = normalizeMatricula(matricula)
  }

  static isValid(matricula: string): boolean {
    if (isMatriculaCocheValid(matricula)) {
      return true
    }

    const normalized = matricula.replace(/\s/g, '').toUpperCase()

    const patronesEspeciales = [
      /^H-[0-9]{4}-[A-Z]{2,3}$/, // Históricas (H-1234-BBC)
      /^(CD|CC|E|CME)-[0-9]{3,4}-[A-Z]{1,3}$/, // Diplomáticas i oficiales
    ]

    return patronesEspeciales.some((regex) => regex.test(normalized))
  }

  value(): string {
    return this.valor
  }
}
